import CountUp from "react-countup";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import "../../assets/css/bebas-neue.css";

const StatisticsBox = ({ title, color, value, sx = {} }) => {
	return (
		<Box
			sx={{
				background: "#F5F5F5",
				padding: "10px 20px",
				flex: { xs: "0 1 20%", xl: "0 1 20%" },
				minWidth: "236px",
				maxWidth: "380px",
				...sx,
			}}
		>
			<Typography variant="span" component="span" sx={{ whiteSpace: "nowrap" }}>
				{title}
			</Typography>
			<Box sx={{ textAlign: "center", padding: "20px 0" }}>
				<Typography
					variant="h2"
					component="span"
					sx={{
						color,
						lineHeight: 1,
						letterSpacing: "-2px",
						whiteSpace: "nowrap",
						fontFamily: `'Bebas Neue', 'Calibri'`,
					}}
				>
					<CountUp
						start={0}
						end={Math.floor(value)}
						duration={2.75}
						separator=" "
					/>
				</Typography>
			</Box>
		</Box>
	);
};

export default StatisticsBox;
